import firebase from '@react-native-firebase/app';
import auth from '@react-native-firebase/auth';
import config from './firebaseConfig';

firebase.initializeApp({
  ...config,
  debug: true,
});

export class AuthProvider {
    init = async () => {
        this.firebaseUser = {
            _user: auth().currentUser
        };
        this.setUserCookiesForWeb();
        this.listenFirebaseTokenChange();
    }

    listenFirebaseTokenChange = () => {
        auth().onAuthStateChanged((user) => {
            if (!user) {
                removeCookie();
            }
        });
    }

    setUserCookiesForWeb = () => {
        const cookieOptions = getCookieOptions();
        Cookies.set(FB_USER_COOKIE_NAME, this.firebaseUser._user, cookieOptions);
    }

    getFirebaseUserId = () => {
        if (!this.firebaseUser._user) {
            return null;
        }
        return this.firebaseUser._user.uid;
    };

    getCurrentUser =() => {
        return this.firebaseUser;
    }

    getAuthorizationHeader = async () => {
        const accessToken = await this.firebaseUser.getIdToken();
        return `Bearer ${accessToken}`;
    };

    firebase = async () => {
        console.log(`AuthProvider: getting firebase access token for user ${this.firebaseUser.uid}`);
        const password = await this.firebaseUser.getIdToken();
        return {
            username: 'firebase',
            password,
        };
    };

    listenFirebaseTokenChange = (callback) => {
        // onFirebaseTokenChange(callback);
    }

    removeAllDeliveredNotifications = () => {
        // return notifications().removeAllDeliveredNotifications();
    }
}

export const getCookieOptions = () => {
    const hostParts = window.location.host.split('.');
    if (window.location.host.indexOf('localhost') === - 1) {
        hostParts.shift();
    }
    const cookieDomainWithPort = `.${hostParts.join('.')}`;
    const portIndex = cookieDomainWithPort.indexOf(':');
    const domain =  portIndex === -1 ? cookieDomainWithPort : cookieDomainWithPort.substring(0, portIndex);
    const expires = 9999;
    return {
        domain,
        expires,
    };
}

export const removeCookie = () => {
    Cookies.remove(FB_USER_COOKIE_NAME, getCookieOptions());
}

export const FB_USER_COOKIE_NAME = 'FB_USER';
